import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { DependencyFilterKeys, HasIssuesFilterOptions } from '../../../../../../shared/dependenciesV2';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import FilterCardNestedCheckboxes from '../../../../generic/Filter/FilterCardNestedCheckboxes';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import type { SelectOption } from '../../../../../types';
import type { SelectedOptionsProps } from '../../../../generic';

// Filter labels by key value
const FILTER_LABELS: Record<string, string> = {
  [HasIssuesFilterOptions.HasLicensingIssues]: 'Licensing',
  [HasIssuesFilterOptions.HasVulnIssues]: 'Security',
  [HasIssuesFilterOptions.HasQualityIssues]: 'Quality',
};

// Built filter options for checkbox filter
const FILTER_OPTIONS: SelectOption[] = Object.entries(FILTER_LABELS).map(([value, label]) => ({
  label, value,
}));

/**
 * Has issues filter which allows the user to filter dependencies with issues.
 * Uses FILTER_LABELS to generate the checkbox filter values.
 */
const HasIssuesFilter: VoidFunctionComponent<Omit<SelectedOptionsProps, 'onSelect'>> = ({ selectedOptions }) => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const selectedCheckboxes = (selectedOptions ?? []).map((option: string) => ({
    label: FILTER_LABELS[option],
    value: option,
  }));

  const onNestedCheckboxChange = (selected: SelectOption[]) => {
    setFilter({
      ...filters,
      [DependencyFilterKeys.HasIssues]: selected.map(({ value }) => value),
    });
  };

  return (
    <FilterCardNestedCheckboxes
      label="Issues"
      parentCheckboxLabel="Has Issues"
      options={FILTER_OPTIONS}
      values={selectedCheckboxes}
      onChange={onNestedCheckboxChange}
    />
  );
};

export default HasIssuesFilter;
